export default (user) => {
  if (!user) return false;
  return user.membershipStatus === 1;
};
